import { execute } from 'utils/API';
import { apiEndoints, httpMethods } from 'utils/constants';
import PropTypes from 'prop-types';

const saveToReware = ({ queryKey }) => {
  return execute(
    httpMethods.GET,
    `${apiEndoints.LIST_FILES}/${queryKey[1]}/SaveReviewSheet`,
    { authorization: queryKey[2] },
    queryKey[3],
    10,
  );
};

saveToReware.propTypes = {
  queryKey: PropTypes.array.isRequired,
};

export { saveToReware };
